<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    Configure Structure Fields
</h1>

<form>
    <!-- Content. -->
    <div mat-dialog-content>
        <kendo-grid [kendoGridBinding]="this.FieldConfigurations"
                    class="field-configuration-kendo-grid">
            <kendo-grid-column field="field" title="Structure Field" [width]="30">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.fieldName}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="hideCheckbox" title="Hide Field?" [width]="20">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <mat-checkbox [checked]="dataItem.DisableForSpecifiedRoles"
                                  (change)="this.hideFieldChangedFor(dataItem,$event)"
                                  name="hideFieldCheckbox">
                        Hide?
                    </mat-checkbox>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="roleNames" title="Role Names" [width]=35>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <mat-select [(value)]="dataItem.RoleNames"
                                name="roleNames"
                                multiple>
                        <mat-option *ngFor="let roleName of this.SiteRoleNames"
                                    [value]="roleName">
                            {{roleName}}
                        </mat-option>

                    </mat-select>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>

    <div class="error-message-div">
        <span class="error-message-span">{{this.ConfigErrorMessage}}</span>
    </div>

    <!-- Action buttons. -->
    <div mat-dialog-actions>
        <button mat-flat-button
                type="submit"
                color="primary"
                class="theme-primary-btn"
                [disabled]="this.SaveButtonDisabled"
                (click)="this.saveClicked()">
            Save
        </button>

        <button mat-stroked-button
                [disabled]="false"
                [mat-dialog-close]="null"
                color="basic"
                style="margin-left: 10px;"
                click="this.cancelClicked()">
            Cancel
        </button>
    </div>

</form>
